import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogConfig,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export interface ScannedDocumentWarningDialogData {
  fileName?: string;
}

export type ScannedDocumentWarningDialogResult = 'upload' | 'manual';

export const scannedDocumentWarningDialogConfig: MatDialogConfig = {
  autoFocus: false,
  width: '520px',
};

@Component({
  selector: 'qt-scanned-document-warning-dialog',
  templateUrl: './scanned-document-warning-dialog.component.html',
  styleUrls: ['./scanned-document-warning-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
})
export class ScannedDocumentWarningDialogComponent {
  private readonly dialogRef =
    inject<
      MatDialogRef<
        ScannedDocumentWarningDialogComponent,
        ScannedDocumentWarningDialogResult
      >
    >(MatDialogRef);
  private readonly data = inject<ScannedDocumentWarningDialogData>(
    MAT_DIALOG_DATA,
    { optional: true }
  );

  readonly fileName = this.data?.fileName ?? '';

  uploadDigital(): void {
    this.dialogRef.close('upload');
  }

  fillOutManually(): void {
    this.dialogRef.close('manual');
  }
}
